/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Records of item arrivals facilitate the tracking and management of item quantities, associated arrival times, and certainty levels. These records distinguish between guaranteed, estimated, and unknown arrival scenarios.
 * @export
 * @interface EntryArrivalSlot
 */
export interface EntryArrivalSlot {
    /**
     * Represents the number of items expected to arrive.
     * @type {number}
     * @memberof EntryArrivalSlot
     */
    quantity?: number;
    /**
     * The date associated with the expected arrival slot.
     * @type {Date}
     * @memberof EntryArrivalSlot
     */
    at?: Date;
    /**
     * The accuracy of the arrival slot as estimated, or unknown.
     * @type {string}
     * @memberof EntryArrivalSlot
     */
    accuracy?: EntryArrivalSlotAccuracyEnum;
}


/**
 * @export
 */
export const EntryArrivalSlotAccuracyEnum = {
    Estimated: 'ESTIMATED',
    Unknown: 'UNKNOWN'
} as const;
export type EntryArrivalSlotAccuracyEnum = typeof EntryArrivalSlotAccuracyEnum[keyof typeof EntryArrivalSlotAccuracyEnum];


/**
 * Check if a given object implements the EntryArrivalSlot interface.
 */
export function instanceOfEntryArrivalSlot(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntryArrivalSlotFromJSON(json: any): EntryArrivalSlot {
    return EntryArrivalSlotFromJSONTyped(json, false);
}

export function EntryArrivalSlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryArrivalSlot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'at': !exists(json, 'at') ? undefined : (new Date(json['at'])),
        'accuracy': !exists(json, 'accuracy') ? undefined : json['accuracy'],
    };
}

export function EntryArrivalSlotToJSON(value?: EntryArrivalSlot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantity': value.quantity,
        'at': value.at === undefined ? undefined : (value.at.toISOString()),
        'accuracy': value.accuracy,
    };
}

